module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('color.label')
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.from.colors,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha"
    },
    model: {
      value: (_vm.newItem.from.color),
      callback: function($$v) {
        _vm.$set(_vm.newItem.from, "color", $$v)
      },
      expression: "newItem.from.color"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('color.label'),
      "columns": 3
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.to.colors,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha"
    },
    model: {
      value: (_vm.newItem.to.color),
      callback: function($$v) {
        _vm.$set(_vm.newItem.to, "color", $$v)
      },
      expression: "newItem.to.color"
    }
  })], 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-col-1@md vertical-center"
  }, [_c('i', {
    staticClass: "i-arrow icon-arrow-right center"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b62e6ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/presets/ecommerce/moovin/marketplace/cnova/ColorAddItem.vue
// module id = 3064
// module chunks = 0